import { useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Star, ChevronRight, UtensilsCrossed } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import placeholderImg from "../../../assets/placeholder-image-two.jpg";
import useDistanceLabel from "../../../customHooks/useDistanceLabel";

export default function KitchenCard({ item }) {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();
  const distanceLabel = useDistanceLabel(item?.address?.lat, item?.address?.lng);

  const handleCardNavigate = () => {
    if (item?._id) {
      navigate(`/sellerprofile/${item._id}`);
    }
  };

  return (
    <motion.div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleCardNavigate}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleCardNavigate();
        }
      }}
      transition={{ duration: 0.25 }}
      role="link"
      tabIndex={0}
      style={{
        width: "100%",
        borderRadius: 18,
        fontFamily: "'Inter', sans-serif",
        cursor: "pointer",
        background: "linear-gradient(160deg, #f8fafc 0%, #f1f5f9 100%)",
        border: hovered ? "1.5px solid #93c5fd" : "1.5px solid #f1f5f9",
        transition: "border-color 0.3s ease",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "30px 16px 16px",
          textAlign: "center",
        }}
      >
        {/* Avatar */}
        <motion.img
          src={item?.kitchenLogo || placeholderImg}
          alt={item?.name || "Kitchen"}
          animate={{ scale: hovered ? 1.08 : 1 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
          style={{
            width: 56,
            height: 56,
            objectFit: "cover",
            borderRadius: "50%",
            border: "3px solid #ffffff",
            display: "block",
            margin: "0 auto 12px",
            boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
          }}
        />

        {/* Kitchen Name */}
        <h3
          style={{
            margin: "0 0 4px",
            fontSize: 14,
            fontWeight: 700,
            color: "#0f172a",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {item?.name || "Kitchen Name"}
        </h3>

        {/* Location */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
            color: "#94a3b8",
            fontSize: 10,
            marginBottom: 12,
          }}
        >
          <MapPin size={10} />
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "80%",
            }}
          >
            {item?.address?.text || "Location not set"}
          </span>
          {distanceLabel && (
            <span style={{ flexShrink: 0 }}>· {distanceLabel}</span>
          )}
        </div>

        {/* Stats */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 14,
            marginBottom: 14,
            fontSize: 11,
            color: "#475569",
          }}
        >
          {/* <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <Star size={11} fill="#facc15" color="#facc15" />
            <span style={{ fontWeight: 700 }}>4.5</span>
          </div> */}

          {/* <div
            style={{
              width: 1,
              height: 14,
              backgroundColor: "#e2e8f0",
            }}
          /> */}

          {/* The public kitchen list carries no dish count — only the kitchen
              profile resolves one, so the stat is hidden rather than shown as 0. */}
          {item?.foodCount != null && (
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <UtensilsCrossed size={11} />
              <span style={{ fontWeight: 600 }}>{item.foodCount}</span>
            </div>
          )}
          {item?.reviews?.count > 0 && (
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <Star size={11} fill="#facc15" color="#facc15" />
              <span style={{ fontWeight: 700 }}>{item.reviews.rating}</span>
            </div>
          )}
        </div>

        {/* Button */}
        <Link
          to={`/wish-order?sellerId=${item?._id}`}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          style={{
            textDecoration: "none",
            display: "block",
            width: "100%",
          }}
        >
          <motion.button
            animate={{
              backgroundColor: hovered ? "#1B6DC1" : "#ffffff",
              color: hovered ? "#ffffff" : "#1e40af",
              borderColor: hovered ? "#fff" : "#bfdbfe",
            }}
            transition={{ duration: 0.2 }}
            style={{
              width: "100%",
              fontWeight: 700,
              padding: "8px 0",
              fontSize: 11,
              border: "1.5px solid #bfdbfe",
              borderRadius: 10,
              cursor: "pointer",
              letterSpacing: 0.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 4,
              textTransform: "uppercase",
            }}
          >
            Any Wish?
            <ChevronRight size={12} />
          </motion.button>
        </Link>
      </div>
    </motion.div>
  );
}
